<script lang="ts" setup>
import { positionPaths } from './consts'
import PositionPath from './PositionPath.vue'
import type { PitchDistance, PitchPosition } from './types'

type Props = {
  disabled?: boolean
}

defineProps<Props>()

// model
const pitchDistance = defineModel<PitchDistance>('pitchDistance', {
  default: null,
})
const pitchPosition = defineModel<PitchPosition>('pitchPosition', {
  default: null,
})

// methods
function toggleDistanceAndPosition(
  distance: PitchDistance,
  position: PitchPosition,
): void {
  if (distance === pitchDistance.value && position === pitchPosition.value) {
    pitchDistance.value = null
    pitchPosition.value = null
  } else {
    pitchDistance.value = distance
    pitchPosition.value = position
  }
}

function isSelected(distance: PitchDistance, position: PitchPosition): boolean {
  return pitchDistance.value === distance && pitchPosition.value === position
}
</script>

<template>
  <svg
    :class="{
      'pointer-events-none opacity-25 grayscale': disabled,
    }"
    width="568"
    height="172"
    viewBox="0 0 568 172"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M447.005 1.5H123.005C123.005 1.5 117.5 22.5 166.005 35.5C206 46.2193 238.004 45.5 287.505 45.5C365.504 45.5 391.004 42 426.005 27.5C449.253 17.8688 447.005 1.5 447.005 1.5Z"
      fill="rgba(245, 247, 250, 1)"
    />
    <PositionPath
      v-for="(path, index) in positionPaths"
      :key="index"
      :distance="path.distance"
      :position="path.position"
      :d="path.d"
      :stroke="path.stroke"
      :stroke-width="path.strokeWidth"
      :stroke-dasharray="path.strokeDashArray"
      :baseFillClass="path.baseFillClass || 'fill-[rgba(186,201,217,1)]'"
      :selected="isSelected(path.distance, path.position)"
      @click="toggleDistanceAndPosition"
    />
    <path
      d="M397 37C413.5 32.5677 425 27.5 425 27.5L454 50C454 50 440 55.7674 414 60C388 64.2326 362.5 64.5 362.5 64.5L360 43C360 43 380.248 41.5 397 37Z"
      stroke="rgba(156,178,201,1)"
      stroke-width="2"
      stroke-dasharray="4 4"
    />
    <path
      d="M498.294 0L567.975 171.85H0L70.3555 0H498.294ZM2.98047 169.85H565.006L496.946 2H71.6982L2.98047 169.85Z"
      fill="white"
    />
    <path
      d="M283.614 141.909C302.934 141.909 320.471 145.092 333.215 150.274C339.584 152.865 344.806 155.974 348.45 159.478C352.098 162.984 354.229 166.952 354.229 171.218H352.229C352.229 167.667 350.462 164.187 347.064 160.92C343.664 157.65 338.69 154.66 332.462 152.127C320.011 147.064 302.741 143.909 283.614 143.909C264.487 143.909 247.218 147.064 234.767 152.127C228.539 154.66 223.565 157.65 220.164 160.92C216.766 164.187 215 167.667 215 171.218H213C213 166.952 215.13 162.984 218.777 159.478C222.422 155.974 227.643 152.865 234.013 150.274C246.757 145.092 264.294 141.909 283.614 141.909Z"
      fill="white"
      fill-opacity="0.5"
    />
    <path
      d="M296.456 49.2637C297.008 49.2638 297.456 49.7114 297.456 50.2637C297.456 50.8159 297.008 51.2636 296.456 51.2637H271C270.448 51.2637 270 50.816 270 50.2637C270 49.7114 270.448 49.2637 271 49.2637H296.456Z"
      fill="white"
    />
    <path
      d="M288.919 31.6172L289.021 31.6221C289.526 31.6732 289.919 32.0994 289.919 32.6172C289.919 33.135 289.526 33.5612 289.021 33.6123L288.919 33.6172H277.49C276.938 33.6172 276.49 33.1695 276.49 32.6172C276.49 32.0649 276.938 31.6172 277.49 31.6172H288.919Z"
      fill="white"
    />
    <path
      d="M63 19.2915C63 19.2915 82.5076 37.8413 116 50.087C165.944 68.348 280.124 66.5175 280.124 66.5175C280.124 66.5175 383.661 66.9909 427.5 57.5C476 47 505 19.6168 505 19.6168"
      stroke="white"
      stroke-width="4"
      stroke-dasharray="12 12"
    />
  </svg>
</template>
